

export enum ScriptMode {
    singlePlantScheduledAction = 'singlePlantScheduledAction',
    multiplePlantsScheduledAction = 'multiplePlantsScheduledAction',
    alarmAction = 'alarmAction'
}